var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bsh-datatable',{attrs:{"columns":_vm.columns,"buttons":_vm.buttons,"link":_vm.$url+'/api/adm/receita/datatable/'+_vm.date,"actionFild":"","sorting":""},on:{"selectRow":_vm.show,"show":_vm.show,"update":_vm.update,"destroy":_vm.destroy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }